/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExtraFieldOptionDto } from './ExtraFieldOptionDto';
import {
    ExtraFieldOptionDtoFromJSON,
    ExtraFieldOptionDtoFromJSONTyped,
    ExtraFieldOptionDtoToJSON,
} from './ExtraFieldOptionDto';

/**
 * 
 * @export
 * @interface ExtraFieldDto
 */
export interface ExtraFieldDto {
    /**
     * 
     * @type {string}
     * @memberof ExtraFieldDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ExtraFieldDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof ExtraFieldDto
     */
    type: ExtraFieldDtoTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ExtraFieldDto
     */
    required: boolean;
    /**
     * 
     * @type {Array<ExtraFieldOptionDto>}
     * @memberof ExtraFieldDto
     */
    options?: Array<ExtraFieldOptionDto>;
}


/**
 * @export
 */
export const ExtraFieldDtoTypeEnum = {
    String: 'string',
    Date: 'date',
    Enum: 'enum',
    Number: 'number'
} as const;
export type ExtraFieldDtoTypeEnum = typeof ExtraFieldDtoTypeEnum[keyof typeof ExtraFieldDtoTypeEnum];


/**
 * Check if a given object implements the ExtraFieldDto interface.
 */
export function instanceOfExtraFieldDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "required" in value;

    return isInstance;
}

export function ExtraFieldDtoFromJSON(json: any): ExtraFieldDto {
    return ExtraFieldDtoFromJSONTyped(json, false);
}

export function ExtraFieldDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtraFieldDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'label': json['label'],
        'type': json['type'],
        'required': json['required'],
        'options': !exists(json, 'options') ? undefined : ((json['options'] as Array<any>).map(ExtraFieldOptionDtoFromJSON)),
    };
}

export function ExtraFieldDtoToJSON(value?: ExtraFieldDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'label': value.label,
        'type': value.type,
        'required': value.required,
        'options': value.options === undefined ? undefined : ((value.options as Array<any>).map(ExtraFieldOptionDtoToJSON)),
    };
}

